import {NgModule} from '@angular/core';
import {BrowserModule} from '@angular/platform-browser';
import {AppRoutingModule} from './app-routing.module';
import {AppComponent} from './app.component';
import {CoreModule} from "./core/core.module";
import {en_US, NZ_I18N} from 'ng-zorro-antd/i18n';
import {registerLocaleData} from '@angular/common';
import en from '@angular/common/locales/en';
import {FormsModule} from '@angular/forms';
import {HTTP_INTERCEPTORS, HttpClientModule} from '@angular/common/http';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {DBConfig, NgxIndexedDBModule} from "ngx-indexed-db";
import {
    MSAL_GUARD_CONFIG,
    MSAL_INSTANCE,
    MsalBroadcastService,
    MsalGuard,
    MsalInterceptor,
    MsalModule,
    MsalService
} from "@azure/msal-angular";
import {MSALGuardConfigFactory, MSALInstanceFactory, MSALInterceptorConfigFactory} from "./auth-config";
import {NzNotificationService} from "ng-zorro-antd/notification";
import {NzModalService} from "ng-zorro-antd/modal";
import {IndexedDBConstants} from "./shared/constants/indexedDBConstants";
import { TourMatMenuModule } from 'ngx-ui-tour-md-menu';
import { NgxPermissionsModule } from 'ngx-permissions';

const rowsDb: DBConfig = {
    name: 'pidbDataBase',
    version: 3,
    objectStoresMeta: [{
        store: IndexedDBConstants.pidbRows,
        storeConfig: {keyPath: 'name', autoIncrement: false},
        storeSchema: []
    }, {
        store: 'pidbHeader',
        storeConfig: {keyPath: 'id', autoIncrement: false},
        storeSchema: []
    },
    {
        store: IndexedDBConstants.oldDocument,
        storeConfig: {keyPath: 'name', autoIncrement: false},
        storeSchema: []
    }]
};

registerLocaleData(en);

/**
 * Root module of the application where we create the indexed database.
 * It also configures
 * and initializes the MSALModule from the Azure MSAL library for authentication and authorization purposes.
 */
@NgModule({
    declarations: [
        AppComponent
    ],
    imports: [
        BrowserModule,
        AppRoutingModule,
        CoreModule,
        FormsModule,
        HttpClientModule,
        BrowserAnimationsModule,
        NgxIndexedDBModule.forRoot(rowsDb),
        MsalModule.forRoot(MSALInstanceFactory(), MSALGuardConfigFactory(), MSALInterceptorConfigFactory()),
        TourMatMenuModule.forRoot(),
        NgxPermissionsModule.forRoot(),
    ],
    providers: [
        {provide: NZ_I18N, useValue: en_US}
        , {
            provide: HTTP_INTERCEPTORS,
            useClass: MsalInterceptor,
            multi: true
        },
        {
            provide: MSAL_INSTANCE,
            useFactory: MSALInstanceFactory
        },
        {
            provide: MSAL_GUARD_CONFIG,
            useFactory: MSALGuardConfigFactory
        },
        MsalService,
        MsalGuard,
        MsalBroadcastService,
        {
            provide: NzNotificationService
        },
        {provide: NZ_I18N, useValue: en_US},
        NzModalService
    ],
    bootstrap: [AppComponent]
})
export class AppModule {
}
